import { EvidenceAttachment } from 'utils/api/modules/risks';

import type { EvidenceFileRow } from './EvidenceFiles';

export const savedEvidenceFiles = (attachments: EvidenceAttachment[]): EvidenceFileRow[] =>
  attachments.flatMap(({ uuid, file }) =>
    file ? [{ key: uuid, filename: file.filename, size: file.size, url: file.url }] : []
  );
